import React, { useEffect,useRef,  useState } from 'react';
import TabMenu from '../Fees/Test';
import CustomTable from '../CustomizeTable';
import AppStrings from '../../config/appstring';
import axios from 'axios';
import CustomTable1 from './ColumnsList';
import SelectDataReport from './SelectDataReports';
import SelectDataReport1 from './SampleDataSet';


const AllReports = ({user}) => {
     

     const [items, setItems] = useState([]);
      const [showSlidePanel, setShowSlidePanel] = useState(false);
      const [activeForm, setActiveForm] = useState(null);
      const [selectedReport, setSelectedReport] = useState(null);
      const [ReportQry, setReportQry] = useState(null);
  
  const pendingReports = [
    'Pending Report 1',
    'Pending Report 2',
    'Pending Report 1',
    'Pending Report 2',
  ];

 useEffect(() => {
console.log("Logged in as:", user?.name);
  fetchReportList();
}, [user]);


  const fetchReportList = () => {
  axios.get(AppStrings.ReportList)
    .then((response) => {
     // console.log(response.data.data, 'list');
      setItems(response.data.data);
    })
    .catch((error) => {
      console.error('Error fetching items:', error);
    });
};

const handleClick = (report) => {
  setShowSlidePanel(false); 
  setActiveForm('Report');
  setSelectedReport(report); // save the full report object
};

  const handleTabCollectFee =   (reportData) => {
   // console.log(reportData.Datas.Title,'rrrrrrrrrrrr')
    setSelectedReport({ ID: 0,HEADER:'' });
  setShowSlidePanel(false); 
  setReportQry(reportData.Datas);
  setActiveForm('Report');      
  
   //console.log('Passed to parent:', reportData.Datas);
};

//console.log(selectedReport.ID,'aaaaaaaaaaaa')
  return (
    <>
    {/* <div style={{ fontSize: '20px',
  fontWeight: 'bold',paddingLeft:'20px'}}>Report List</div> */}
   <button style={NameButton}
                        onClick={() => {
    setShowSlidePanel(true);
     fetchReportList();  
  }}
                        >
    Report List 👈 Click Me
    </button>
    <div className="report-grid">
      {items.map((report, index) => (
        <div key={index} className="report-item">
          <button onClick={() => handleClick(report)} className="report-button">
             {/* <span className="report-icon">📄</span> */}
            {report.HEADER}
          </button>
        </div>
      
      ))}


{showSlidePanel  && (
  <div style={{ ...slidePanelStyle, ...slidePanelVisible }}>

     <button 
            style={closeButtonStyle}
            onClick={() => setShowSlidePanel(false)}
            aria-label="Close Slide Panel"
          >
            ✖
          </button>

 <CustomTable1 
  onClose={() => {
    setShowSlidePanel(false);
    fetchReportList(); // Refresh after save
  }}
  onCollectFeeClick={handleTabCollectFee} 
/>
 
    
  </div>
)}


{/* Report Form (e.g. modal) */}
{activeForm === 'Report' && (selectedReport || ReportQry) && (
  <div style={modalContentStyle}>
    <button 
      style={closeButtonStyle}
      onClick={() => setActiveForm(null)} 
      aria-label="Close Slide Panel"
    >
      ✖
    </button>
    
    <SelectDataReport 
      REPORTLISTNAME={{
        id: selectedReport.ID || '0',  // safe optional chaining
        qry: ReportQry,
        Header:selectedReport.HEADER
      }}
      onClose={() => {
        setActiveForm(null);
        setItems([]);
          fetchReportList(); // Refresh after save
      }}
    />
  </div>
)}




    </div>
      </>
  );
};

export default AllReports;

const NameButton = {
  width: '100%',
  height: 'auto',
  backgroundColor: 'transparent',
  color: 'black',
  textAlign: 'left',
  border: 'none',
  padding: '0',
  margin: '0',
  fontWeight: 'bold',
  cursor: 'pointer',
  fontSize:'25px'
}

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  zIndex: 999,
};


const modalContentStyle = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 1000,
  backgroundColor: '#fff',
  padding: '20px',
  borderRadius: '8px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.25)',
  width: '80vw',          // Adjust as needed (e.g. 600px or 80vw)
  height: '80vh',         // Adjust height similarly
  overflowY: 'auto',      // Scroll if content overflows vertically
  overflowX: 'auto'     // Hide horizontal scroll unless needed
};



const closeButtonStyle = {
  marginBottom: 10,
  padding: '6px 0px',
  background: '#fff',
  border: 'none',
  borderRadius: 4,
  cursor: 'pointer',
  color:'black',
  width:'20px'
};
const slidePanelVisible = {
  transform: 'translateX(0%)',  // visible on screen
};
const slidePanelStyle = {
  position: 'fixed',
  top: 0,
  right: 0,
  width: '25%',
  height: '100%',
  backgroundColor: '#fff',
  zIndex: 1000,
  padding: '20px',
  transform: 'translateX(100%)',  // hidden initially off screen right
  transition: 'transform 0.3s ease-in-out',
  borderTopLeftRadius: '20px',
  borderBottomLeftRadius: '20px',
  boxShadow: '-2px 0 8px rgba(0, 0, 0, 0.3)',
};

